import { EditIcon } from "../../../icons/CommonIcons";
import Button from "../../common/Button";

const TabButton = ({ label, isActive, onClick, language = false }) => {
  const showEditIcon = typeof label === "object" ? label?.en?.toLowerCase() === "subsidy evaluation" : label?.toLowerCase() === "subsidy evaluation";
  return (
    <Button
      onClick={onClick}
      className={`flex items-center gap-2 px-3 py-2 rounded text-sm sm:text-md font-semibold ${
        isActive ? "bg-btn text-white" : "bg-gray-200 hover:bg-gray-300"
      }`}
    >
      <span></span>
      {language ? label.hi : label.en}

      {showEditIcon && (
        <EditIcon
          fill={`${isActive ? "white" : "text-gray-600"}`}
          className={`w-6 h-6 ${isActive ? "text-white" : "text-gray-600"}`}
        />
      )}
    </Button>
  );
};

export default TabButton;
